import React from 'react';
import PropTypes from 'prop-types';

const withOnVisibleFacilityHandler = (Component) => {
	const WithOnVisibleFacilityHandler = ({
		percentVisible = 70,
		...props
	}) => {
		const onVisible = (delay) => {
			if (typeof props.onVisible !== 'function') return;
			props.onVisible({
				facility_id: props.facility.id,
				visible_threshold: percentVisible,
				index: props.facility.index,
				rank: props.facility.position,
				in_network: props.facility.inNetwork,
				delay,
			});
		};

		return (
			<Component
				{...props}
				percentVisible={percentVisible}
				onVisible={onVisible}
			/>
		);
	};
	WithOnVisibleFacilityHandler.propTypes = {
		percentVisible: PropTypes.number,
		onVisible: PropTypes.func,
		facility: PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			index: PropTypes.number,
			position: PropTypes.number,
			inNetwork: PropTypes.bool,
		}).isRequired,
	};
	WithOnVisibleFacilityHandler.displayName = `withOnVisibleFacilityHandler(${Component.displayName || Component.name || 'Component'})`;
	return WithOnVisibleFacilityHandler;
};

export default withOnVisibleFacilityHandler;
